module.exports = __webpack_public_path__ + "img/TrueCallerHeaderv0.2.573ac32b.png";